import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab';
import { usePhotoOptimisticEdits } from 'javascripts/hooks';

// #region styled-components
const AssetContainer = styled.div`
  position: relative;
  flex: none;
  width: 50px;
  height: 50px;
  margin-top: var(--cc_size_spacing_xs);
  margin-left: var(--cc_size_spacing_xl);
`;

const Asset = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: ${tokens.size_border_radius_m}px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
`;

const Video = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const PlayIcon = styled.i`
  opacity: 0.8;
  color: var(--cc_color_link_secondary);
  font-size: 20px;

  ${AssetContainer}:hover & {
    opacity: 1;
  }
`;

const Overlay = styled.div`
  z-index: 100;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  background: linear-gradient(transparent 50%, rgba(0, 0, 0, 0.3));
  padding: 8px;
`;
// #endregion

const ProjectTaskAssets = ({ taskAssets = [], onTaskAssetClick }) => {
  const { getOptimisticUri } = usePhotoOptimisticEdits();

  return (
    <>
      {taskAssets.map((taskAsset) => (
        <AssetContainer
          key={taskAsset.id}
          onClick={() => {
            onTaskAssetClick({
              initialAsset: taskAsset,
              taskAssets,
            });
          }}
        >
          {taskAsset.__typename === 'Video' ? (
            <Overlay>
              <Video className="dark-environment">
                <PlayIcon className="mdi mdi-play-circle-outline" />
              </Video>
            </Overlay>
          ) : null}

          <Asset
            key={taskAsset.id}
            src={
              getOptimisticUri(taskAsset.databaseId) ||
              taskAsset.assetPreviewThumbnail
            }
          />
        </AssetContainer>
      ))}
    </>
  );
};

ProjectTaskAssets.propTypes = {
  taskAssets: PropTypes.array,
  onTaskAssetClick: PropTypes.func,
};

export default ProjectTaskAssets;
